import React, {useState, lazy, Suspense, useEffect} from 'react';
import BBIconQuickViewMagnifying from "../../../assets/bbCustomIcons/BBIconQuickViewMagnifying";
import {Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import {useDispatch, useSelector} from "react-redux";
import {
    bbFindEntityWithinPortfolioOrSelf
} from "../../../util/bbHelpers";
import {Col, Row} from "reactstrap";
import BBIconPrinterOutput from "../../../assets/bbCustomIcons/BBIconPrinterOutput";
// import {Tooltip} from "@mui/material";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Skeleton from "react-loading-skeleton";
import BRBusinessVectorCards from "../BRDetailedReports/BRBusinessVectorCards";
import {fetchRiskCycleReport} from "../../../actions";

const BRVectorCardsDialog = ({vectorId=null, iconOnly = false, cycleId=null}) =>{

    // console.log("THIS IS THE VECTOR PASSED FORM TA BLE", vector)

    // const BRBusinessVectorCardsREVAMP = lazy(()=> import("../BRDetailedReports/BRBusinessVectorCards"))

    const {customers, customerInView} = useSelector(({customer}) => customer);

    const {entityInView, portfolios, loadingCycleTargets, loadingVectorResults, loadingVectorResultsError, loadingCycles, loadingCyclesError} = useSelector(({breachrisk}) => breachrisk);

    const customerId = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerId] : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerId);
    // const lastCycleId = myEntity ? myEntity.last_cycle : null;
    const lastCycle = myEntity
        && myEntity.cycles
        && myEntity.settings
        && myEntity.settings.last_cycle_id
            ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const dispatch = useDispatch();

    useEffect(()=>{
        if(pastReportView && !loadingCycles[cycleId]){
            if (cycleId
                && myEntity
                && myEntity.cycles
                && !myEntity.cycles[cycleId]) {
                dispatch(fetchRiskCycleReport({
                    customerId: customerId,
                    cycleId: cycleId
                }))
            }
        }
    }, [cycleId, pastReportView])

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;

    const threatVectors = techData
    && techData.totals
        ? techData.totals.vectors
        : null;

    const vector = threatVectors
    && threatVectors.find(x=> x.id === vectorId)
        ? threatVectors.find(x=> x.id === vectorId)
        : null;

    const targets = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.targets : null;


    const targetId = vector && vector.target;

    // console.log("threatVectors", threatVectors, "vectorId", vectorId, "vector", vector);
    const indexOfTargetId = targets
        && targets
            .findIndex(x => x.Id === targetId);
    const target = (loadingCycleTargets
        && !loadingCycleTargets[targetId])
        && targets
        && targets[indexOfTargetId];

    const testedVectorDetails = vector && vector.tested_vector_details
    const results = testedVectorDetails && testedVectorDetails.results ? testedVectorDetails.results : null;
    const hasResults = results && Object.keys(results).length > 0;

    // const dot = <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>

    // const color = bbTranslateBreachRiskScoreToColor(vectorScore, true)
    // const category = bbTranslateBreachRiskScoreToCategory(vectorScore);

    const [open, setOpen] = useState(false);

    return(
        <span>
            <Tooltip title={"View Details"}>
                {iconOnly
                    ? <IconButton
                    onClick={()=> setOpen(true)}
                >
                    <BBIconQuickViewMagnifying/>
                </IconButton>
                    : <p style={{cursor: "pointer"}} className={"d-inline"}
                        onClick={()=> setOpen(true)}>
                        {vector
                        && vector.definition
                            && vector.definition.name
                            ? vector.definition.name : "...Loading"}
                </p>}
            </Tooltip>


            {open && vector
                && <Dialog open={open}
                    fullWidth={true}
                    fullScreen={false}
                    maxWidth={"lg"}
                    className={"m-1 p-1 animated fadeIn animation-duration-6"}
                    aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title" >
                    <Row>
                        <Col lg={11}/>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>window.print()}
                                style={{ margin: "0", padding: "0", alignItems: "center", alignContent: "center"}}>
                                <BBIconPrinterOutput
                                    className={"mb-2 close"}
                                />
                            </IconButton>
                        {/*</Col>*/}
                            &nbsp;
                            &nbsp;
                        {/*<Col lg={1} className={"text-right"}>*/}
                            <IconButton
                                onClick={()=>setOpen(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
                <DialogContent>
                    <div>
                        {/*<Suspense fallback={<Card className={"m-0 p-0 animated fadeIn animation-duration-12"}>*/}
                        {/*        <div className={"card-header"} style={{width:"100%"}}>*/}
                        {/*            Loading Threat Vector Details...*/}
                        {/*            <Row>*/}
                        {/*                <Col>*/}
                        {/*                    <h2>*/}
                        {/*                        <Skeleton count={6}/>*/}
                        {/*                    </h2>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </div>*/}
                        {/*</Card>}>*/}
                        <Col lg={12}>
                            <BRBusinessVectorCards vector={vector}
                                                   threatVector={vector}
                                                   entityId={entityInView}
                                                   target={target}
                                                         isOpen={open}
                            />
                        </Col>
                        {/*</Suspense>*/}
                    </div>

                </DialogContent>
                <DialogActions>
                    <Row>
                        <Col>

                        </Col>
                    </Row>
                </DialogActions>
            </Dialog>}
        </span>
    )
}

export default BRVectorCardsDialog;